import React, { useMemo } from 'react';
import type { CitationTarget, FileRecord, ReaderVisualizationState } from '@reados/contracts';
import { ReadOSTranscript } from './ReadOSTranscript';
import { documentMessage } from './document';
import type {DocumentFollowUpSource} from './visualizations';
import type { RendererTheme } from './presentation';
const EMPTY_FILES: FileRecord[] = [];

export interface ReadOSDocumentProps {
  document: FileRecord;
  source: string;
  inspectionId?: string;
  readOnly?: boolean;
  onAccessDenied?: (message:string) => void;
  files?: FileRecord[];
  onNavigate?: (target: CitationTarget) => void;
  onFollowUp?: (text: string, source?: DocumentFollowUpSource) => void;
  states?: Record<string, unknown>;
  onStateChange?: (states: Record<string, unknown>) => void;
  onVisualizationsChange?: (items: ReaderVisualizationState[]) => void;
  assetBaseUrl?: string;
  theme?: RendererTheme;
  /** Hidden readers retain their source/state but pause active media and DIL. */
  visible?: boolean;
}

/** Markdown files use the same copied Markdown, citation, media and Intelligent
 * UI pipeline as chat. Only the frame presentation and resource base differ. */
export function ReadOSDocument({ document, source, files = EMPTY_FILES, ...props }: ReadOSDocumentProps) {
  const messages = useMemo(() => [documentMessage(document, source)], [document.id, document.contentRevision, source]);
  const availableFiles = useMemo(() => files.some(file => file.id === document.id) ? files : [...files, document], [document, files]);
  // A move changes relative resources even when the bytes/revision stay the
  // same. Recreate host caches while retaining the file/revision state scope.
  return <ReadOSTranscript key={document.sandboxPath} {...props} messages={messages} files={availableFiles} transcriptScope={messages[0].id}
    presentation="document" visualizationSource={{fileId:document.id,contentRevision:document.contentRevision}} referenceBasePath={document.sandboxPath} title={document.name} />;
}
